<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>


                <rkm-col
                    cols="2"
                    v-if="model.laboratorio.valorSigtap == false || model.exigeProcedimento == false"
                >
                    <rkm-form-input
                        label="Valor do exame"
                        ref="valorExame"
                        v-model="model.laboratorio.valor"
                        v-money="money"
                        prepend="R$"
                        :validations="validations.valor"
                        key="valorExame"
                    />
                </rkm-col>

                <rkm-col
                    cols="2"
                    v-if="model.laboratorio.valorSigtap == true && model.procedimento && model.exigeProcedimento == true"
                >
                    <rkm-form-input
                        label="Valor sigtap"
                        ref="valorSigtap"
                        v-model="model.procedimento.valorServicoAmbilatorial"
                        disabled
                        v-money="money"
                        prepend="R$"
                        key="valorSigtap"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Prazo de entrega"
                        number
                        v-model="model.laboratorio.prazoEntrega"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Validade do exame"
                        number
                        v-model="model.laboratorio.validade"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor d-flex pa-2 float-right"
                        small
                        v-rkm-popover.hover.left="{
                            html:true,
                            content: 'Quantidade máxima de pedido.'
                        }"
                    />
                    <rkm-form-input
                        label="Quantidade máxima"
                    number
                        v-model="model.laboratorio.quantidadeMaxima"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor d-flex pa-2 float-right"
                        small
                        v-rkm-popover.hover.top="{
                            html:true,
                            content: 'Posição que o exame será ordenado no mapa. Ordenação crescente.'
                        }"
                    />
                    <rkm-form-input
                        label="Posição mapa"
                        v-model="model.laboratorio.posicaoMapa"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor d-flex pa-2 float-right"
                        small
                        v-rkm-popover.hover.top="{
                            html:true,
                            content: 'Quantidade de resultados disponível na impressão.'
                        }"
                    />
                    <rkm-form-input
                        label="Último resultado"
                        text-field="Último resultado"
                        v-model="model.laboratorio.ultimoResultado"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col cols="2" v-if="model.exigeProcedimento == true">
                    <rkm-form-checkbox
                        inline
                        v-model="model.laboratorio.valorSigtap"
                        @change="selecionarSigtap"
                    >
                        Valor do sigtap
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-checkbox
                        v-model="model.laboratorio.sigilo"
                        inline
                    >
                        Sigilo
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-checkbox
                        v-model="model.laboratorio.outroMunicipio"
                        inline
                    >
                        Outro município
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-checkbox
                        v-model="model.laboratorio.provisorio"
                        inline
                    >
                        Provisório
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-checkbox
                        v-model="model.laboratorio.senhaSupervisor"
                        inline
                    >
                        Senha supervisor
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-checkbox
                        v-model="model.laboratorio.mapaAgrupado"
                        inline
                    >
                        Mapa agrupado
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="2" class="mt-2">
                    <rkm-form-input
                        label="Quantidade de reagentes"
                        number
                        v-model="model.laboratorio.quantidadeReagente"
                    />
                </rkm-col>

                <rkm-col cols="2" class="mt-2">
                    <rkm-form-checkbox
                        :label="false"
                        name="PermiteRepeticao"
                        v-model="model.laboratorio.permiteRepeticao"
                        inline
                    >
                        Permite repetição
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row>
            <rkm-col>

                <rkm-area
                    title="Composição do exame"
                    class="mt-3"
                >

                    <rkm-button
                        @click="$refs.List.openModal()"
                        color="primary"
                        slot="trailing"
                        small
                        title="Adicionar composição"
                    >
                        <rkm-icon icon="plus" />
                    </rkm-button>

                    <rkm-button
                        v-if="id"
                        @click="print()"
                        color="secondary"
                        slot="trailing"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="$refs.TextoPronto.open()"
                        color="info"
                        slot="trailing"
                        small
                        title="Texto pronto"
                    >
                        <rkm-icon icon="file-alt" />
                    </rkm-button>

                    <List
                        ref="List"
                        :form="form"
                        :model="model"
                    />
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <TextoPronto
            :data="{form, model}"
            ref="TextoPronto"
        />
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error } from '@/mixins'

// Components.
import List from './components/List'
import TextoPronto from './components/texto-pronto/Modal'

//Directives
import { VMoney } from 'v-money'

export default {
    components: {
        List,
        TextoPronto
    },
    computed:{
        maskValor(){

            var mascara = '##,##'

            if (this.model.laboratorio.valor && this.model.laboratorio.valor.length < 6){
                mascara = '##,##'
            }
            else if (this.model.laboratorio.valor && this.model.laboratorio.valor.length < 7){
                mascara = '###,##'
            }
            else if (this.model.laboratorio.valor && this.model.laboratorio.valor.length < 9){
                mascara = '#.###,##'
            }

            return mascara
        },
        validations() {
            return {
                valor: {max: 12},
            }
        },
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        id: { type: Number }
    },
    directives: { money: VMoney },
    mixins: [repository, error],
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.parametrizacao')
        }
    },
    data:() => ({
        selecionados: false,
        money: {
          decimal: ',',
          thousands: '.',
          suffix: '',
          precision: 2,
          masked: false
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        validate() {
            return this.$refs.Form.validate()
        },
        selecionarSigtap(){

            if(this.selecionados == true){

                this.selecionados = false
            } else {

                this.selecionados = true
            }
        },
        print() {

        this.setLoading()

        this.repositories.impressao.exameComposicao(this.id)
            .then(response => {

                const content = new Blob([response.data], {type: response.headers['content-type']})
                const url = URL.createObjectURL(content)
                const link = document.createElement('a')

                link.href = url
                link.target = '_blank'
                link.click()
                link.remove()
            })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
}
</script>